/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RankingsInputs */

const id_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat`)
};

const ms_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan`)
};

const da_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangeringer`)
};

const de_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranglisten`)
};

const en_us2_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rankings`)
};

const es_es2_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rankings`)
};

const es_mx2_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rankings`)
};

const fil_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Ranggo`)
};

const fr_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classements`)
};

const it_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifiche`)
};

const hu_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangsorok`)
};

const nl_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranglijsten`)
};

const no_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangeringer`)
};

const pl_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rankingi`)
};

const pt_br2_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações`)
};

const pt_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações`)
};

const ro_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasamente`)
};

const fi_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sijoitukset`)
};

const sv_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rankningar`)
};

const vi_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng xếp hạng`)
};

const tr_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sıralamalar`)
};

const cs_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žebříčky`)
};

const bg_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Класации`)
};

const ru_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинги`)
};

const uk_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинги`)
};

const ar_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التصنيفات`)
};

const hi_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रैंकिंग`)
};

const th_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อันดับ`)
};

const ja_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランキング`)
};

const zh_cn2_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排行榜`)
};

const zh_hant1_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排行榜`)
};

const ko_nav_rankings = /** @type {(inputs: Nav_RankingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순위`)
};

/**
* | output |
* | --- |
* | "Rankings" |
*
* @param {Nav_RankingsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_rankings = /** @type {((inputs?: Nav_RankingsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RankingsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_rankings(inputs)
	if (locale === "ms") return ms_nav_rankings(inputs)
	if (locale === "da") return da_nav_rankings(inputs)
	if (locale === "de") return de_nav_rankings(inputs)
	if (locale === "en-US") return en_us2_nav_rankings(inputs)
	if (locale === "es-ES") return es_es2_nav_rankings(inputs)
	if (locale === "es-MX") return es_mx2_nav_rankings(inputs)
	if (locale === "fil") return fil_nav_rankings(inputs)
	if (locale === "fr") return fr_nav_rankings(inputs)
	if (locale === "it") return it_nav_rankings(inputs)
	if (locale === "hu") return hu_nav_rankings(inputs)
	if (locale === "nl") return nl_nav_rankings(inputs)
	if (locale === "no") return no_nav_rankings(inputs)
	if (locale === "pl") return pl_nav_rankings(inputs)
	if (locale === "pt-BR") return pt_br2_nav_rankings(inputs)
	if (locale === "pt") return pt_nav_rankings(inputs)
	if (locale === "ro") return ro_nav_rankings(inputs)
	if (locale === "fi") return fi_nav_rankings(inputs)
	if (locale === "sv") return sv_nav_rankings(inputs)
	if (locale === "vi") return vi_nav_rankings(inputs)
	if (locale === "tr") return tr_nav_rankings(inputs)
	if (locale === "cs") return cs_nav_rankings(inputs)
	if (locale === "bg") return bg_nav_rankings(inputs)
	if (locale === "ru") return ru_nav_rankings(inputs)
	if (locale === "uk") return uk_nav_rankings(inputs)
	if (locale === "ar") return ar_nav_rankings(inputs)
	if (locale === "hi") return hi_nav_rankings(inputs)
	if (locale === "th") return th_nav_rankings(inputs)
	if (locale === "ja") return ja_nav_rankings(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_rankings(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_rankings(inputs)
	return ko_nav_rankings(inputs)
});
export { nav_rankings as "nav.rankings" }